import React from 'react'
import { Button } from 'semantic-ui-react'
import GoogleButton from 'react-google-button'

import { AllowPermission } from 'shared/components/AllowPermission'
import Oauth2PasswordCredentialAuthenticateModal from './Oauth2PasswordCredentialAuthenticateModal'
import Oauth2WithPropertiesModal from './Oauth2WithPropertiesModal'
import useUser from 'hooks/useUser'
import * as R from 'ramda'
import useFeatureToggle from 'hooks/useFeatureToggle'
import constants from 'config/constants'
import AuthenticateModal from './AuthenticateModal'

export default function CyclrIntegrationAuthenticationSegment({
  name,
  isAuthenticated,
  onActivate,
  onDeactivate,
  loading,
  authenticatioType,
  authenticationSettings,
  connectorProperties,
  isAuthenticateSuccessful,
  oauthRedirectUrl,
}) {
  const user = useUser()
  const { enableNewBillingPlan } = useFeatureToggle()
  const planMetadata = user.subscription.subscription_items_metadata
  let allowPremiumIntegration = true

  function handleBasicAuthSubmit(fields) {
    const username = R.prop('value', R.find(R.propEq('name', 'username'), fields))
    const password = R.prop('value', R.find(R.propEq('name', 'password'), fields)) || ''
    const properties = R.filter((field) => field.type === 'properties', fields)
    onActivate({ username, password, properties })
  }

  function handleApiKeyAuthSubmit(fields) {
    const apiKey = R.prop('value', R.find(R.propEq('name', 'api_key'), fields))
    const properties = R.filter((field) => field.type === 'properties', fields)
    onActivate({ apiKey, properties })
  }

  function handleNoneAuthSubmit(fields) {
    onActivate({ properties: fields })
  }

  if (
    name.toLowerCase() === 'salesforce' &&
    R.prop('premium_integrations', planMetadata) === 'false'
  ) {
    allowPremiumIntegration = false
  }

  if (isAuthenticated) {
    return (
      <div className="ui segment">
        <div className="ui stackable grid">
          <div className="ten wide column middle aligned">
            <h4>
              <i className="ui icon fas fa-check green" />
              Authenticated with {name}
            </h4>
          </div>

          <AllowPermission permission={constants.permissions.manageIntegrations}>
            <div className="six wide column right aligned">
              <Button basic negative onClick={onDeactivate} loading={loading} disabled={loading}>
                Revoke access
              </Button>
            </div>
          </AllowPermission>
        </div>
      </div>
    )
  } else {
    return (
      <div className="ui secondary segment !bg-white">
        <div className="ui stackable grid">
          <div className="ten wide column middle aligned">
            <h4>
              <i className="ui icon info circle" />
              Connect your {name} account with Simplesat
            </h4>
          </div>
          <div className="six wide column right aligned">
            {authenticatioType === 'basic' && (
              <AllowPermission permission={constants.permissions.manageIntegrations}>
                <AuthenticateModal
                  authenticationSettings={authenticationSettings}
                  connectorProperties={connectorProperties}
                  loading={loading}
                  isAuthenticateSuccessful={isAuthenticateSuccessful}
                  onSubmit={handleBasicAuthSubmit}
                />
              </AllowPermission>
            )}
            {authenticatioType === 'api_key' && (
              <AllowPermission permission={constants.permissions.manageIntegrations}>
                <AuthenticateModal
                  authenticationSettings={authenticationSettings}
                  connectorProperties={connectorProperties}
                  loading={loading}
                  isAuthenticateSuccessful={isAuthenticateSuccessful}
                  onSubmit={handleApiKeyAuthSubmit}
                />
              </AllowPermission>
            )}
            {authenticatioType === 'none' && (
              <AuthenticateModal
                authenticationSettings={authenticationSettings}
                connectorProperties={connectorProperties}
                loading={loading}
                isAuthenticateSuccessful={isAuthenticateSuccessful}
                onSubmit={handleNoneAuthSubmit}
              />
            )}
            {authenticatioType === 'oauth2' && (
              <AllowPermission permission={constants.permissions.manageIntegrations}>
                {connectorProperties.length ? (
                  <Oauth2WithPropertiesModal
                    authenticationSettings={authenticationSettings}
                    connectorProperties={connectorProperties}
                    onActivate={onActivate}
                    loading={loading}
                    isAuthenticateSuccessful={isAuthenticateSuccessful}
                    allowPremiumIntegration={allowPremiumIntegration}
                    enableNewBillingPlan={enableNewBillingPlan}
                    isGoogleConnector={name.toLowerCase().includes('google')}
                  />
                ) : // check connector_name
                name.toLowerCase().includes('google') ? (
                  <div className="flex justify-end">
                    <a href={oauthRedirectUrl} rel="noopener">
                      <GoogleButton disabled={!oauthRedirectUrl} />
                    </a>
                  </div>
                ) : (
                  <a href={oauthRedirectUrl} rel="noopener">
                    <Button primary disabled={!oauthRedirectUrl}>
                      Authenticate
                    </Button>
                  </a>
                )}
              </AllowPermission>
            )}

            {authenticatioType === 'oauth2_password_credential' && (
              <AllowPermission permission={constants.permissions.manageIntegrations}>
                <Oauth2PasswordCredentialAuthenticateModal
                  authenticationSettings={authenticationSettings}
                  connectorProperties={connectorProperties}
                  onActivate={onActivate}
                  loading={loading}
                  isAuthenticateSuccessful={isAuthenticateSuccessful}
                />
              </AllowPermission>
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CyclrIntegrationAuthenticationSegment/index.tsx